<table
      mat-table
      [dataSource]="allUsers"
      class="mat-elevation-z2 member-settings-table"
    >
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef class="header-cell">Username</th>
        <td mat-cell *matCellDef="let element">
          <div class="container">
            <div class="admin-container">
              <span>{{ element.username }}</span>
              <mat-chip-option *ngIf="element.isAdmin" disabled>Admin</mat-chip-option>
            </div>
            <button
              *ngIf="!element.isLocked"
              mat-icon-button
              (click)="openEditMemberDialog(element)"
              [disabled]="element.isLocked"
            >
              <img src="/assets/icons/edit-icon.svg" />
            </button>
            <button
              *ngIf="element.isLocked"
              mat-icon-button
              (click)="openEditMemberDialog(element)"
              [disabled]="element.isLocked"
            >
              <img src="/assets/icons/edit-icon-disabled.svg" />
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef class="header-cell">Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.memberName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="idNumber">
        <th mat-header-cell *matHeaderCellDef class="header-cell">NWMO ID</th>
        <td mat-cell *matCellDef="let element">{{ element.idNumber }}</td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="header-cell">Actions</th>
        <td mat-cell *matCellDef="let element">
          <button
            class="blue-outline-button"
            mat-stroked-button
            color="primary"
            [ngClass]="{ 'disabled-button': element.isLocked }"
            [disabled]="element.isLocked"
            (click)="impersonate(element)"
          >
            IMPERSONATE
          </button>
          <button
            *ngIf="!element.isLocked"
            class="blue-outline-button"
            mat-stroked-button
            color="primary"
            (click)="openLockDialog(element)"
          >
            LOCK
          </button>
          <button
            *ngIf="element.isLocked"
            class="blue-outline-button"
            mat-stroked-button
            color="primary"
            (click)="openLockDialog(element)"
          >
            UNLOCK
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
